import { Button } from "@devhop/ui";
import { LayersIcon, PlusIcon, RefreshCwIcon, UsersIcon } from "lucide-react";

type ClassSessionToolbarProps = {
  canManage?: boolean;
  canUpdate?: boolean;
  bulkUpdateEnabled?: boolean;
  onCreate: () => void;
  onBulkCreate?: () => void;
  onBulkUpdateTemplate?: () => void;
  onBulkUpdateInstructors?: () => void;
};

export function ClassSessionToolbar({
  canManage,
  canUpdate,
  bulkUpdateEnabled,
  onCreate,
  onBulkCreate,
  onBulkUpdateTemplate,
  onBulkUpdateInstructors,
}: ClassSessionToolbarProps) {
  return (
    <div className="mb-6 flex items-center justify-between gap-4 max-sm:flex-col max-sm:items-start">
      <div>
        <h1 className="font-bold text-3xl tracking-tight">ຈັດຕາຕະລາງຄລາດສ໌</h1>
        <p className="mt-1 text-muted-foreground text-sm">
          ຈັດການ ຊົ່ວໂມງຮຽນ ຄລາດສ໌ທີ່ຈະເກີດຂຶ້ນ
        </p>
      </div>
      {(canManage || canUpdate) && (
        <div className="flex flex-wrap gap-2">
          {canUpdate && onBulkUpdateTemplate && (
            <Button
              variant="outline"
              onClick={onBulkUpdateTemplate}
              disabled={!bulkUpdateEnabled}
            >
              <RefreshCwIcon className="size-4" />
              ອັບເດດແມ່ແບບ (Bulk)
            </Button>
          )}
          {canUpdate && onBulkUpdateInstructors && (
            <Button
              variant="outline"
              onClick={onBulkUpdateInstructors}
              disabled={!bulkUpdateEnabled}
            >
              <UsersIcon className="size-4" />
              ອັບເດດຄູສອນ (Bulk)
            </Button>
          )}
          {canManage && onBulkCreate && (
            <Button variant="outline" onClick={onBulkCreate}>
              <LayersIcon className="size-4" />
              ສ້າງຫຼາຍຊົ່ວໂມງຮຽນ
            </Button>
          )}
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="size-4" />
              ສ້າງຊົ່ວໂມງຮຽນໃໝ່
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
